import { render, staticRenderFns } from "./OrderViewForm.vue?vue&type=template&id=cedfee16&"
import script from "./OrderViewForm.vue?vue&type=script&lang=js&"
export * from "./OrderViewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports